import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  paymentMethodFromModel,
  validatePaymentMethodCondition,
  type PaymentMethodState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PAYMENT_METHOD = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PaymentMethodState>>,
): ConditionType<PaymentMethodState, Condition.PaymentMethod> => ({
  name: CONDITION_NAMES[Condition.PAYMENT_METHOD],
  description(state) {
    return state !== undefined
      ? t("Payment method was: {{method}}", { method: state })
      : t("The payment method used for the original order");
  },
  Details(props: ConditionTypeDetailsProps<PaymentMethodState>) {
    return React.createElement(Details, props);
  },
  empty: null,
  fromModel(model) {
    return paymentMethodFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PAYMENT_METHOD, method: state };
  },
  valid(state) {
    return validatePaymentMethodCondition(state).valid;
  },
});
